// extracted by mini-css-extract-plugin
export default {"submenu":"styles_submenu__-Kzz5","active":"styles_active__+yUji"};